// MobileFindPw.jsx
import { useEffect, useState } from "react";
import MobileHeader from "../component/MobileHeader";
import FindPw1 from "../findIdPw/FindPw1";
import FindPw2 from "../findIdPw/FindPw2";
import { useNavigate } from "react-router-dom";

export default function MobileFindPw() {
    const [step, setStep] = useState(0);
    const navigate = useNavigate();

    // 🔹 이전 단계에서 받은 컨텍스트(id, phoneNumber) 보관
    const [ctx, setCtx] = useState({ id: null, phoneNumber: null });

    // 🔹 새로고침 복구
    useEffect(() => {
        const saved = sessionStorage.getItem("findPwCtx");
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                if (parsed?.id && parsed?.phoneNumber) {
                    setCtx(parsed);
                    setStep(1); // 저장된 컨텍스트가 있으면 바로 2단계로
                }
            } catch { }
        }
    }, []);

    const handleNextFromStep1 = (payload) => {
        // payload: { id, phoneNumber } (FindPw1에서 보냄)
        setCtx(payload);
        sessionStorage.setItem("findPwCtx", JSON.stringify(payload));
        setStep(1);
    };

    const handleDone = () => {
        sessionStorage.removeItem("findPwCtx");
        setCtx({ id: null, phoneNumber: null });
        navigate("/", { replace: true }); // ✅ 여기서 이동
    };

    return (
        <nav className="Nav_FindPw">
            <MobileHeader onPrev={() => window.history.back()} />

            {step === 0 && (
                <FindPw1
                    // ✅ 1단계: 본인인증 후 id/phoneNumber 전달
                    onNext={handleNextFromStep1}
                />
            )}

            {step === 1 && (
                <FindPw2
                    // ✅ 2단계: 새 비번 입력 후 /password/reset 호출
                    id={ctx.id} phoneNumber={ctx.phoneNumber} onDone={handleDone}
                />
            )}
        </nav>
    );
}
